import { COLOR_TOKENS } from './color-tokens';

// Matches any color/finish word from COLOR_TOKENS as a whole word, case-insensitive.
// Capture group 1 is the matched word.
export const TOKEN_PATTERN = new RegExp(`\\b(${COLOR_TOKENS.join('|')})\\b`, 'i');
